exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-block{position:relative;top:10px!important}.password-reset-block{display:block;color:#287f23}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./Scripts/app/PasswordReset/PasswordReset.vue?vue&type=style&index=0&id=4212d62c&prod&lang=css
// module id = 1041
// module chunks = 2